export const privacyContent = `
<p>Настоящая Политика обработки персональных данных (далее — Политика) определяет порядок
сбора, хранения, обработки и защиты персональных данных пользователей интернет-ресурса
<strong>bilet.rabt.by</strong>.</p>

<p><strong>Оператор персональных данных:</strong><br>
ООО «Региональное агентство безопасности труда»<br>
УНП 591023480, 230023, г. Гродно, ул. 1 мая, 19<br>
тел./факс: 8 (0152) 60 92 24 &nbsp;|&nbsp; тел.: +375 29 286 11 99<br>
e-mail: <a href="mailto:office@rabt.by">office@rabt.by</a></p>

<h3>1. Какие данные собираются</h3>

<p><strong>1.1. Учётная запись и профиль</strong></p>
<ul>
  <li>Адрес электронной почты — используется как идентификатор для входа и связи с пользователем.</li>
  <li>Имя и фамилия — для персонализации профиля.</li>
  <li>Номер телефона — по желанию пользователя, для связи.</li>
  <li>Организация и специализация — для подбора подходящих категорий тестов.</li>
  <li>Дата экзамена и город сдачи — для планирования подготовки.</li>
</ul>

<p><strong>1.2. Договор об оказании образовательных услуг (LMS)</strong></p>
<p>При оформлении договора на дистанционное обучение собираются следующие данные:</p>
<ul>
  <li>ФИО на русском и белорусском языках слушателей и заказчика.</li>
  <li>Серия, номер паспорта, дата выдачи, орган выдачи.</li>
  <li>Адрес места жительства (регистрации).</li>
  <li>Адрес электронной почты слушателя (для предоставления доступа к LMS).</li>
  <li>Для юридических лиц и ИП: наименование организации, УНП, юридический и почтовый адрес,
  контактный телефон, e-mail, должность и ФИО подписанта, основание полномочий,
  коды ОКЭД/ОКПО/ОКЮЛП (при автоматической проверке по базе ИМНС).</li>
</ul>

<p><strong>1.3. Платёжные данные</strong></p>
<ul>
  <li>Сумма и статус платежа, дата оплаты.</li>
  <li>Реквизиты платёжного поручения ЕРИП (номер счёта, номер счёт-фактуры).</li>
  <li>Данные банковской карты <em>не хранятся</em> на ресурсе — они обрабатываются
  непосредственно ЗАО «Альфа-Банк» через защищённый платёжный шлюз.</li>
</ul>

<p><strong>1.4. Данные об обучении</strong></p>
<ul>
  <li>История прохождения тестов: количество вопросов, правильных и неправильных ответов,
  время начала и завершения сессии.</li>
</ul>

<p><strong>1.5. Технические данные</strong></p>
<ul>
  <li>IP-адрес, тип браузера и устройства — собираются автоматически при использовании
  ресурса для обеспечения работоспособности и безопасности сервиса.</li>
</ul>

<h3>2. Цели и правовые основания обработки</h3>
<ul>
  <li>Исполнение договора об оказании услуг (ст. 6 Закона Республики Беларусь «О защите
  персональных данных» от 7 мая 2021 г. № 99-З).</li>
  <li>Создание и управление учётной записью пользователя.</li>
  <li>Оформление и исполнение договоров об образовательных услугах.</li>
  <li>Обработка платежей через банк-эквайер.</li>
  <li>Направление информационных сообщений об актуальных курсах и мероприятиях (с согласия
  пользователя, указанного в договоре).</li>
  <li>Обеспечение технической поддержки.</li>
</ul>

<h3>3. Передача данных третьим лицам</h3>
<p>3.1. Персональные данные не передаются третьим лицам, за исключением случаев, необходимых
для исполнения договора:</p>
<ul>
  <li><strong>ЗАО «Альфа-Банк»</strong> — для обработки платежей по банковским картам и
  через систему ЕРИП.</li>
  <li>Государственные органы — в случаях, предусмотренных законодательством Республики
  Беларусь.</li>
</ul>
<p>3.2. Оператор не продаёт и не передаёт персональные данные в маркетинговых целях.</p>

<h3>4. Хранение и защита данных</h3>
<p>4.1. Данные хранятся на защищённых серверах с применением технических и организационных
мер, исключающих несанкционированный доступ.</p>
<p>4.2. Пароли пользователей хранятся в хешированном виде и не могут быть восстановлены
Оператором.</p>
<p>4.3. Данные хранятся в течение срока действия учётной записи, а после её удаления — в
течение срока, установленного законодательством Республики Беларусь об архивном деле
и бухгалтерском учёте (не менее 10 лет для первичных документов, в т. ч. договоров).</p>

<h3>5. Права субъекта персональных данных</h3>
<p>В соответствии с Законом Республики Беларусь «О защите персональных данных» каждый
пользователь вправе:</p>
<ul>
  <li>получить информацию о составе и целях обработки своих персональных данных;</li>
  <li>потребовать исправления неточных данных;</li>
  <li>отозвать согласие на обработку данных, обрабатываемых на основании согласия;</li>
  <li>потребовать удаления данных (если их хранение не обусловлено законодательством).</li>
</ul>
<p>Для реализации прав следует обратиться по адресу:
<a href="mailto:office@rabt.by">office@rabt.by</a>.</p>

<h3>6. Файлы cookie</h3>
<p>Интернет-ресурс использует файлы cookie для поддержания сеанса авторизации и обеспечения
корректной работы сервиса. Файлы cookie не содержат персональных данных в явном виде и не
передаются третьим лицам.</p>

<h3>7. Изменение политики</h3>
<p>Оператор вправе вносить изменения в настоящую Политику. Актуальная версия размещается на
интернет-ресурсе bilet.rabt.by. Продолжение использования ресурса после внесения изменений
означает согласие с обновлённой Политикой.</p>

<h3>8. Контакты</h3>
<p>По вопросам, связанным с обработкой персональных данных, обращайтесь:<br>
e-mail: <a href="mailto:office@rabt.by">office@rabt.by</a><br>
тел./факс: 8 (0152) 60 92 24</p>
`;
